"use client"

import { useReelsStore } from "@/app/(tabs)/reels/store/reelsStore"
import { usePathname } from "next/navigation"
import { useEffect, useRef } from "react"
import { useBottomSheetStore } from "../common/bottomSheet/store/useBottomSheetStore"
import { usePopupStore } from "../common/popup/store/usePopupStore"

function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>(value)
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

const RouteObserver = () => {
  const pathname = usePathname()
  const prevPathname = usePrevious(pathname)
  const { clearData } = useReelsStore()
  const { closeSheet } = useBottomSheetStore()
  const { closePopup } = usePopupStore()

  const mounted = useRef(false)
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      return
    }
    console.log(`🚀 현재 경로: ${pathname} => 🚀 이전 경로 ${prevPathname}`)
    closeSheet()
    closePopup()
  }, [pathname, prevPathname, clearData, closeSheet, closePopup])

  return <></>
}

export default RouteObserver
